import { type ChangeEvent, type FC } from 'react';

import {
  IconPlayerPlay,
  IconSettings,
} from '@tabler/icons-react';
import { ButtonField, SelectField } from '@wk/components-react16';

import { ENVIRONMENTS } from '@/config/constants';
import type { Application } from '@/types';

import SubscribeBellPopover from './SubscribeBellPopover';

interface ApplicationDetailsToolbarProps {
  application?: Application;
  selectedEnvironment: string;
  onEnvironmentChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  onNavigateToConfiguration: () => void;
  onOpenRunEvaluation: () => void;
}

const ApplicationDetailsToolbar: FC<ApplicationDetailsToolbarProps> = ({
  application,
  selectedEnvironment,
  onEnvironmentChange,
  onNavigateToConfiguration,
  onOpenRunEvaluation,
}) => (
  <div className="flex w-full justify-between gap-4 max-sm:flex-col">
    <SelectField size="small">
      <select value={selectedEnvironment} onChange={onEnvironmentChange}>
        {ENVIRONMENTS.map((environment) => (
          <option key={environment} value={environment}>
            {environment}
          </option>
        ))}
      </select>
    </SelectField>
    <div className="flex items-center gap-3 justify-between max-sm:w-full">
      {application ? (
        <SubscribeBellPopover
          bitId={application.bitId}
          applicationName={application.name}
          environment={selectedEnvironment}
        />
      ) : null}
      <ButtonField size="small">
        <button onClick={onNavigateToConfiguration}>
          <IconSettings size={14} />
          View Configuration
        </button>
      </ButtonField>
      <ButtonField mode="ghost" size="small">
        <button onClick={onOpenRunEvaluation}>
          <IconPlayerPlay size={14} />
          Run Evaluation
        </button>
      </ButtonField>
    </div>
  </div>
);

export default ApplicationDetailsToolbar;
